<template>
  <div v-if="isLoadingCpn">
    <md-card class="communication-log-student">
      <md-card-header class="md-card-header-text md-card-header-green">
        <div class="card-text">
          <h4 class="title text-lg">{{ $t("student.communication_log") }}</h4>
        </div>
      </md-card-header>

      <md-card-content>
        <communication-log-form-add
          @add-new="addNewCommunication"
          @clear-form="clearForm"
          v-if="isTabCommunicationLog && isAddCommunicationLog"
          :key="componentKey"
        ></communication-log-form-add>
        <yv-index
          :path="path"
          :columns="columns"
          :limit="limit"
          :formSearch="formSearch"
          hideBulkAction="true"
          hideNoNumber="true"
          hasArrayRes="true"
          :tableActionsComponent="TableActions"
          :formatTableData="formatTableData"
          ref="communicationTable"
        >
        </yv-index>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import { service_names } from "@/constants/Services";
import { YvIndex } from "@/components/Base";
import TableActions from "./TableActions.vue";
import { Message } from "@/helpers/utils";
import CommunicationLogFormAdd from "./CommunicationLogFormAdd";
import { Student } from "@/constants/Permissions";
import Swal from "sweetalert2";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  components: {
    CommunicationLogFormAdd,
    YvIndex
  },
  props: ["isTabCommunicationLog", "isActiveTab"],
  data() {
    const studentId = this.$route.params.id;
    return {
      pathAddNew: `${service_names.school}/communication-log`,
      path: `${service_names.school}/communication-log?student_id=${studentId}`,
      TableActions,
      columns: {
        date_of_contact: "student.date_of_contact",
        staff_in_contact: "student.staff_in_contact",
        method_value: "student.method",
        concerns_value: "student.concerns",
        communication_details: "student.communication_detail",
        responses_from_parent: "student.responses_from_parent"
      },
      limit: 20,
      componentKey: 0,
      isLoadingCpn: false,
      isActive: false,
      formSearch: [
        {
          label: "student.select_date_range",
          name: "date_range",
          value: [],
          type: "date-range"
        }
      ]
    };
  },
  computed: {
    isAddCommunicationLog() {
      return this.$can(Student.actions.editCommunicationLog, Student.subject);
    }
  },
  watch: {
    isActiveTab: function(newVal) {
      if (this.isActive) return;
      if (newVal) {
        this.isLoadingCpn = true;
        this.isActive = true;
      }
    }
  },
  methods: {
    addNewCommunication(form) {
      if (!form.date_of_contact)
        form.date_of_contact = new Date().toISOString().slice(0, 10);
      this.$axios.post(this.pathAddNew, form).then(() => {
        Message.success(this.$t("common.success"));
        this.reRenderComponent();
        this.getTableData();
      });
    },
    clearForm() {
      this.reRenderComponent();
    },
    reRenderComponent() {
      this.componentKey++;
    },
    formatTableData(tableData) {
      tableData?.data?.forEach(item => {
        item.date_of_contact = convertDateFromServer(
          item.date_of_contact,
          "date"
        );
        item.method_value = item.method.replaceAll("-", " ");
        const regexVariable = /_|-/gi;
        item.concerns_value = item.concerns.map(item =>
          item.replaceAll(regexVariable, " ")
        );
        item.communication_details = `<p class="leading-6 whitespace-pre-line">${item.communication_detail}</p>`;
        item.responses_from_parent = `<p class="leading-6 whitespace-pre-line">${item.response_from_parent}</p>`;
        let user = item.created_by?.user_no_sql;
        item.staff_in_contact =
          user?.full_name + (user?.staff_code ? " - " + user.staff_code : "");
      });
      return tableData.data;
    },
    editCommunicationLog(item) {
      this.$emit("edit-communication", item);
    },
    deleteCommunicationLog(id) {
      Swal.fire({
        title: this.$t("common.are_you_sure"),
        text: this.$t("common.you_wont_be_able_to_revert_this"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes_delete_it"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.delete(id);
        }
      });
    },
    delete(id) {
      this.$axios
        .delete(`${service_names.school}/communication-log/${id}`)
        .then(() => {
          this.$refs.communicationTable.getTableData();
          Message.success(this.$t("common.success"));
        });
    },
    getTableData() {
      return this.$refs.communicationTable.getTableData();
    }
  },
  provide() {
    return {
      editCommunicationLog: this.editCommunicationLog,
      deleteCommunicationLog: this.deleteCommunicationLog
    };
  }
};
</script>
<style lang="scss">
.communication-log-student {
  label {
    font-size: 14px !important;
  }
}
</style>
